import type { CartelaItem, FiltroCartelas } from "../../../services/cartelasFornecedor"

export enum CartelasFornecedorActionsTypes {
    CARREGAR_RESULTADO = "CARREGAR_RESULTADO",
    ATUALIZAR_FILTRO_CAMPO = "ATUALIZAR_FILTRO_CAMPO",
    MUDAR_PAGINA = "MUDAR_PAGINA",
    LIMPAR_FILTRO = "LIMPAR_FILTRO",
}

export type CartelasFornecedorAction =
    | {
          type: CartelasFornecedorActionsTypes.CARREGAR_RESULTADO
          payload: {
              cartelas: CartelaItem[]
              total: number
              permiteResgateIncompleta: boolean
              isAdmin: boolean
          }
      }
    | {
          type: CartelasFornecedorActionsTypes.ATUALIZAR_FILTRO_CAMPO
          payload: { campo: keyof FiltroCartelas; valor: string }
      }
    | {
          type: CartelasFornecedorActionsTypes.MUDAR_PAGINA
          payload: { pagina: number }
      }
    | {
          type: CartelasFornecedorActionsTypes.LIMPAR_FILTRO
      }
